export default {
  addWidgetTitle: "Add a widget"
}
